import { useState } from "react";
import { Plus } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { Reveal } from "./Reveal";

const FAQS = [
  {
    q: "Нужно ли мне что-то знать о Human Design заранее?",
    a: "Нет. Чтение подходит и для тех, кто только знакомится с системой. Я объясняю основные элементы простым и понятным языком.",
  },
  {
    q: "Что нужно для составления карты?",
    a: "Дата, место и точное время рождения.",
  },
  {
    q: "Нужно ли верить в Human Design?",
    a: "Нет. Я предлагаю относиться к системе как к инструменту для наблюдения за собой и самостоятельно проверять то, что Вам откликается.",
  },
  {
    q: "В каком формате проходит консультация?",
    a: "Основная часть чтения проходит в формате персонального аудиоразбора. После его прослушивания мы проводим онлайн-встречу, где можно задать вопросы и обсудить то, что особенно важно именно для Вас.",
  },
];

export const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="mx-auto max-w-[1240px] px-6 py-28 md:px-10 md:py-40">
      <div className="grid gap-12 md:grid-cols-[0.8fr_1.2fr] md:gap-20">
        <Reveal>
          <div className="md:sticky md:top-28 md:self-start">
            <span className="font-serif text-7xl italic text-sand md:text-8xl">04</span>
            <h2 className="mt-6 font-serif text-4xl leading-tight tracking-tight text-charcoal md:text-5xl">
              Вопросы и ответы
            </h2>
          </div>
        </Reveal>

        <div className="border-t border-charcoal/15">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border-b border-charcoal/15">
                <button
                  data-testid={`faq-toggle-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-6 py-7 text-left"
                >
                  <span className="font-serif text-2xl leading-snug tracking-tight text-charcoal md:text-3xl">
                    {f.q}
                  </span>
                  <Plus
                    className={
                      "h-5 w-5 shrink-0 text-sage transition-transform duration-500 " +
                      (isOpen ? "rotate-45" : "")
                    }
                    strokeWidth={1.4}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      key="content"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="max-w-xl pb-8 font-sans text-base font-light leading-relaxed text-charcoal/70">
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
